import { useEffect, useState, type FC } from "react";
import styles from "./CallTimer.module.css";

interface Props {
  callStartTime: number | null;
}

const formatElapsed = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const CallTimer: FC<Props> = ({ callStartTime }) => {
  const [elapsed, setElapsed] = useState<string>("");

  useEffect(() => {
    if (callStartTime === null) {
      setElapsed("");
      return;
    }

    const update = () => setElapsed(formatElapsed(Date.now() - callStartTime));
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [callStartTime]);

  if (!elapsed) return null;

  return <span className={styles.timer} aria-label="Call duration">{elapsed}</span>;
};
